import { Box, Button, Card, CircularProgress, Typography } from "@mui/material";
import BackIcon from "components/AppIcons/BackIcon";
import FaiBox from "MuiComponents/FaiBox";
import FaiTypography from "MuiComponents/FaiTypography";
import DataList from "screens/Catalog/Inventory/component/DataList";
import dataTableData from "../data/ordersTableData";
import SearchInput from "components/SearchInput";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import Axios from "services/api/config";
import { getCustomerOrdersURL } from "services/api/routes/Sale";

export default function CustomerDetails({ customerDetails, setCustomer }) {
	const [ordersList, setOrderList] = useState([]);
	const [loading, setLoading] = useState(false);

	const getCustomerOrders = async () => {
		try {
			setLoading(true);
			const { data } = await Axios({
				...getCustomerOrdersURL({
					customerId: customerDetails.id,
					page: 0,
					size: 5,
				}),
			});
			setOrderList(data.data?.data || []);
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getCustomerOrders();
	}, []);

	return (
		<div className="space-y-2">
			<Card className="my-6 p-3 md:p-6 space-y-4">
				<Box className="flex justify-between">
					<Button
						startIcon={<BackIcon />}
						onClick={() => setCustomer()}
						className="!p-1 text-theme"
					>
						Back to Customers
					</Button>
				</Box>
				<Box>
					<Box className="rounded-2xl p-2" sx={{ backgroundColor: "#F9E9DA" }}>
						<div className="rounded-2xl flex gap-4 justify-between bg-white p-4">
							{/* <div></div> */}
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									Customer Id
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									#{customerDetails?.id}
								</Typography>
							</FaiBox>
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									Customer Name
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									{customerDetails?.name}
								</Typography>
							</FaiBox>
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									Email
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									{customerDetails?.email}
								</Typography>
							</FaiBox>
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									Phone Number
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									{customerDetails?.phone}
								</Typography>
							</FaiBox>
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									DOB
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									{customerDetails?.dob
										? dayjs(customerDetails?.dob).format("DD-MM-YYYY")
										: "-"}
								</Typography>
							</FaiBox>
						</div>
					</Box>
				</Box>
			</Card>
			<Card className="my-6 p-3 md:p-6">
				<FaiBox>
					<FaiTypography
						variant="h4"
						className="!text-xl !font-semibold"
						mb={2}
					>
						Orders
					</FaiTypography>
					<FaiTypography variant="p" className="!text-sm" mb={2}>
						View and manage all your orders here. You can track the status,
						update order details, and process shipments. Use the search option
						to quickly find a specific order.
					</FaiTypography>
				</FaiBox>
				<Box className="flex flex-col md:flex-row justify-between items-center my-4 w-full gap-3">
					<SearchInput placeholder="Search By User ID" />
				</Box>
				<Box sx={{ mt: 2 }}>
					{loading ? (
						<CircularProgress />
					) : (
						<DataList
							data={{
								...dataTableData,
								rows: ordersList,
							}}
							// onRowClick={setPaymentDetails}
						/>
					)}
				</Box>
			</Card>
		</div>
	);
}
